import {
  REQUEST_EXPENSE_CATEGORIES,
  RECEIVE_EXPENSE_CATEGORIES,
  RECEIVE_PERSONALIZED_EXPENSE_CATEGORIES,
  RECEIVE_STATIC_CATEGORIES,
} from '../../actions/tax/expenses';

const initialState = {
  categories: [],
  staticCategories: {},
  displayed: [],
  displayedByJob: {},
  isFetching: false,
};

export default function expenses(state = initialState, action) {
  switch (action.type) {
    case REQUEST_EXPENSE_CATEGORIES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_EXPENSE_CATEGORIES:
      return {
        ...state,
        categories: action.data.categories,
        displayedByJob: {
          ...state.displayed,
          [action.data?.professionIds?.sort().join('-')]: action.data.displayed,
        },
        isFetching: false,
      };
    case RECEIVE_PERSONALIZED_EXPENSE_CATEGORIES:
      return {
        ...state,
        categories: action.data.categories,
        displayed: action.data.displayed,
        isFetching: false,
      };
    case RECEIVE_STATIC_CATEGORIES:
      return {
        ...state,
        staticCategories: { ...state.staticCategories, ...action.data },
        isFetching: false,
      };
    default:
      return state;
  }
}
